// EXZMOTO — cursor.js
// Lumanice cursor + image color reveal + button aura

(function () {
  'use strict';

  // ── CREATE CURSOR DOM ────────────────────────────────────────
  var cursor = document.createElement('div');
  cursor.id = 'exz-cursor';
  cursor.innerHTML =
    '<div class="cursor-ring"></div>' +
    '<div class="cursor-dot"></div>' +
    '<div class="cursor-glow"></div>';
  document.body.appendChild(cursor);

  var ring  = cursor.querySelector('.cursor-ring');
  var dot   = cursor.querySelector('.cursor-dot');
  var glow  = cursor.querySelector('.cursor-glow');

  // Actual mouse pos (snappy)
  var mx = -200, my = -200;
  // Lagged glow pos
  var glowX = -200, glowY = -200;
  var ringX = -200, ringY = -200;

  // ── MOUSE MOVE ───────────────────────────────────────────────
  document.addEventListener('mousemove', function (e) {
    mx = e.clientX;
    my = e.clientY;
  });

  // ── RAF LOOP — smooth cursor movement ────────────────────────
  function lerp(a, b, t) { return a + (b - a) * t; }

  function tick() {
    // Ring follows with slight lag
    ringX = lerp(ringX, mx, 0.18);
    ringY = lerp(ringY, my, 0.18);

    // Glow follows with more lag
    glowX = lerp(glowX, mx, 0.08);
    glowY = lerp(glowY, my, 0.08);

    // Snap dot directly
    dot.style.transform = 'translate(' + mx + 'px,' + my + 'px) translate(-50%,-50%)';

    // Ring with lag
    ring.style.transform = 'translate(' + ringX + 'px,' + ringY + 'px) translate(-50%,-50%)';

    // Glow with heavy lag
    glow.style.transform = 'translate(' + glowX + 'px,' + glowY + 'px) translate(-50%,-50%)';

    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);

  // ── CURSOR STATE CLASSES ─────────────────────────────────────
  var BTNS  = 'a[href], button, .product-add-btn, .btn-primary, .btn-outline, .newsletter-submit, .cart-discount-btn, .pagination-btn, .footer-social-link, .gallery-thumb, .variant-btn, .sort-select, .mobile-nav-link, .nav-hamburger, .cart-drawer-close, .product-accordion-title';
  var IMGS  = '.product-img img, .hero-img-main img, .hero-img-small img, .blog-card-img img, .article-hero-img img, .gallery-slide img';
  var CARDS = '.bike-card, .col-card, .product-card, .blog-card, .feat-card';

  function setState(type) {
    document.body.classList.remove('cursor-btn', 'cursor-img', 'cursor-link');
    if (type) document.body.classList.add('cursor-' + type);
  }

  document.addEventListener('mouseover', function (e) {
    var t = e.target;
    if (t.closest && t.closest(IMGS)) {
      setState('img');
    } else if (t.matches && (t.matches(BTNS) || t.closest(BTNS.split(', ').map(function(s){return s.trim();}).join(', ')))) {
      setState('btn');
    } else {
      setState(null);
    }
  });

  // ── BUTTON AURA — track mouse within each button ─────────────
  var auraTargets = document.querySelectorAll(
    '.btn-primary, .btn-outline, .product-add-btn, .newsletter-submit, ' +
    '.cart-discount-btn, .pagination-btn, .footer-social-link'
  );

  auraTargets.forEach(function (el) {
    el.addEventListener('mousemove', function (e) {
      var rect = el.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width * 100).toFixed(1) + '%';
      var y = ((e.clientY - rect.top)  / rect.height * 100).toFixed(1) + '%';
      el.style.setProperty('--mx', x);
      el.style.setProperty('--my', y);
    });
  });

  // ── IMAGE COLOR REVEAL LENS ──────────────────────────────────
  // For bike cards and collection cards that have grayscale imgs,
  // we clone the image in full color and reveal via clip-path circle

  // Spotlight lens — brightens image under cursor
  function setupSpotlight(card) {
    var img = card.querySelector('img');
    if (!img) return;

    // Create spotlight overlay
    var spot = document.createElement('div');
    spot.style.cssText = [
      'position:absolute',
      'inset:0',
      'z-index:3',
      'pointer-events:none',
      'background:radial-gradient(circle 100px at 50% 50%, rgba(255,255,255,0.18) 0%, transparent 70%)',
      'opacity:0',
      'transition:opacity 0.25s'
    ].join(';');
    card.appendChild(spot);

    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var cx = ((e.clientX - rect.left) / rect.width  * 100).toFixed(2) + '%';
      var cy = ((e.clientY - rect.top)  / rect.height * 100).toFixed(2) + '%';
      spot.style.background = 'radial-gradient(circle 110px at ' + cx + ' ' + cy + ', rgba(255,255,255,0.22) 0%, transparent 70%)';
      spot.style.opacity = '1';
    });

    card.addEventListener('mouseleave', function () {
      spot.style.opacity = '0';
    });
  }

  document.querySelectorAll('.bike-card, .col-card, .product-card, .hero-right').forEach(setupSpotlight);

  // ── PRODUCT CARDS — full color on hover, greyscale at rest ───
  // Product images are already full color (we fixed that), so just
  // add a nice color-pop scale on the image itself
  document.querySelectorAll('.product-card').forEach(function (card) {
    var img = card.querySelector('.product-img img:not(.product-img-hover)');
    if (!img) return;

    card.addEventListener('mouseenter', function () {
      img.style.filter = 'brightness(1.05) saturate(1.15)';
    });
    card.addEventListener('mouseleave', function () {
      img.style.filter = '';
    });
  });

  // ── HIDE CURSOR WHEN LEAVING WINDOW ─────────────────────────
  document.addEventListener('mouseleave', function () {
    cursor.style.opacity = '0';
  });
  document.addEventListener('mouseenter', function () {
    cursor.style.opacity = '1';
  });

  // ── CLICK BURST ─────────────────────────────────────────────
  document.addEventListener('mousedown', function () {
    ring.style.transform += ' scale(0.85)';
    ring.style.transition = 'transform 0.1s ease';
  });
  document.addEventListener('mouseup', function () {
    ring.style.transition = 'width 0.35s cubic-bezier(.23,1,.32,1), height 0.35s cubic-bezier(.23,1,.32,1), border-color 0.3s, background 0.3s, opacity 0.3s';
  });

  // ── TOUCH: disable cursor on touch devices ───────────────────
  window.addEventListener('touchstart', function () {
    cursor.style.display = 'none';
    document.querySelectorAll('*').forEach(function(el){
      el.style.cursor = '';
    });
  }, { once: true });

})();